import React, { FC, useEffect, useRef, useState } from "react";
import "moment/locale/id";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { HttpGet } from "../../providers/HttpClient";

const Info = (): JSX.Element => {
  const [datas, setDatas] = useState([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  let scrollTimer = useRef(null);
  const scrollRef = useRef(null);
  const doubledData = [...datas, ...datas];

  const getInfo = () => {
    HttpGet("member/info?size=20&page=0&sort=createTime&dir=-1").then(
      (res: any) => {
        setDatas(res.data.content);
      }
    );
  };

  const handleUserScroll = () => {
    setIsUserScrolling(true);
    clearInterval(scrollTimer.current);

    // Mulai auto-scroll lagi setelah 5 detik tidak ada interaksi
    setTimeout(() => setIsUserScrolling(false), 5000);
  };

  useEffect(() => {
    if (!isUserScrolling) {
      scrollTimer.current = setInterval(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollBy({
            left: 5, // jarak geser (px)
            behavior: "smooth",
          });
        }
      }, 5000); // interval 3 detik
    }

    return () => clearInterval(scrollTimer.current);
  }, [isUserScrolling]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      setIsUserScrolling(true);
      clearTimeout((handleScroll as any)._timeout);
      (handleScroll as any)._timeout = setTimeout(() => {
        setIsUserScrolling(false);
      }, 150);

      // Loop ke tengah
      if (
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth * 2
      ) {
        container.scrollLeft = container.clientWidth;
      } else if (container.scrollLeft <= 0) {
        container.scrollLeft =
          container.scrollWidth / 2 - container.clientWidth;
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getInfo();
  }, []);
  return (
    <div className="">
      <p className="mb-2 font-header text-sm font-bold">Info & Berita</p>
      {/* <div className="flex overflow-x-auto max-h-50 flex-nowrap"> */}
      <div
        ref={scrollRef}
        onScroll={handleUserScroll}
        className="flex overflow-x-auto scroll-smooth flex-nowrap gap-3 mr-2"
        style={{ scrollSnapType: "x mandatory" }}
      >
        {doubledData.map((item: any, key) => (
          <div
            key={key}
            className="min-w-[80%] h-fit shadow-sm rounded-2xl relative bg-white scroll-snap-align-start"
            style={{ scrollSnapAlign: "start" }}
            onClick={() => setSelectedImage(item.image)}
          >
            <div className="flex h-32">
              {item.image && (
                <div className="flex w-full">
                  <img
                    className="rounded-t-2xl h-32 w-full object-cover"
                    src={item.image}
                    alt={"info" + key}
                  />
                </div>
              )}
            </div>
            <div className="flex flex-col px-2 py-2 gap-1.5">
              <h1 className="text-sm font-normal text-black text-left m-0">
                {item.name}
              </h1>
            </div>
          </div>
        ))}
      </div>

      {/* </div> */}

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-4xl max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Preview"
              className="max-h-[90vh] max-w-full rounded-lg shadow-lg"
            />
            <button
              className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center text-white bg-black bg-opacity-50 rounded-full hover:bg-opacity-80"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Info;
